(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play/assets/javascripts/marketplace-wager-paid.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play/assets/javascripts/marketplace-wager-paid.js');
"use strict";

const {
  useGetMarketplaceWalletPaid
} = svs.components.tipsen.hooks;
const {
  dialog
} = svs.components;
const {
  useRef
} = React;
const MarketplaceWagerPaid = () => {
  const hasDialogTriggered = useRef(false);
  const hasActiveMarketplaceWalletPaid = useGetMarketplaceWalletPaid();
  if (hasActiveMarketplaceWalletPaid && !hasDialogTriggered.current) {
    hasDialogTriggered.current = true;
    dialog.api.add(new dialog.Confirm({
      branding: dialog.branding.SPORT,
      type: dialog.type.DEFAULT,
      title: 'Ditt spel är redan betalt',
      message: [{
        type: dialog.message.TEXT,
        text: 'Du kan stänga denna flik.'
      }],
      actions: [{
        title: 'Stäng',
        showLoader: true,
        callback() {
          dialog.api.close();
        }
      }]
    }));
  }
  return null;
};
setGlobal('svs.components.tipsen.routePlay.MarketplaceWagerPaid', MarketplaceWagerPaid);

 })(window);